/**
 * GET /v1/incidents — list incidents for the current school (active +
 * scheduled + resolved). Drives the web POC list screen at
 * `/school/comms/incidents`. The response shape is the lightweight
 * `Incident` (no participants / claims) — detail is fetched per-row
 * via GET /v1/incidents/:publicId.
 */

import { z } from 'zod'

import { IncidentSchema, IncidentStatusSchema } from '../../schemas/entities/incident'

/**
 * `status` is a CSV query param: `?status=active,scheduled`.
 * Empty / missing = no status filter (return everything).
 */
export const ListIncidentsRequestSchema = z.object({
  status: z
    .string()
    .optional()
    .transform(value =>
      value
        ? value
            .split(',')
            .map(s => s.trim().toUpperCase())
            .filter(Boolean)
        : undefined
    )
    .pipe(z.array(IncidentStatusSchema).optional()),
  limit: z.coerce.number().int().positive().max(200).optional()
})
export type ListIncidentsRequest = z.infer<typeof ListIncidentsRequestSchema>

export const ListIncidentsResponseSchema = z.object({
  data: z.array(IncidentSchema),
  meta: z.object({
    total: z.number()
  })
})
export type ListIncidentsResponse = z.infer<typeof ListIncidentsResponseSchema>
